import type { ParentType as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { GetCustomRibbonsByParentTypeResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetRibbonItemsByParentTypeQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRibbonItemsByParentTypeDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetRibbonItemsByParentTypeArgs = {
  parentType: Parent_Type_Enum;
};

export const useGetRibbonItemsByParentType = createQueryHook<
  UseGetRibbonItemsByParentTypeArgs,
  GetCustomRibbonsByParentTypeResponseRow[],
  GetRibbonItemsByParentTypeQuery
>({
  trpcQueryOptions: (trpc, { parentType }) =>
    trpc.frontend.customRibbon.byParentType.queryOptions({ parentType }),
  mapTrpcDataToGraphQL: (data) => ({
    custom_ribbon: data ?? [],
  }),
  graphqlDocument: GetRibbonItemsByParentTypeDocument,
  graphqlVariables: ({ parentType }) => ({ parentType }),
});
